import { Col, Row } from 'antd';
import React, { ReactNode } from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './Section.module.scss';
import Text from '../../Atoms/Text';
import Spacer from '../../Atoms/Spacer';
import 'antd/es/row/style/css';
import 'antd/es/col/style/css';
import cn from 'classnames';
import { joinClassnames } from 'helpers/classNames';

type TSectionProps = {
  title: string | ReactNode;
  subTitle?: string;
  actionText: string;
  children?: React.ReactNode;
  withBorder?: boolean;
  onAction?: () => void;
  rowClassname?: string;
  productRowClassname?: string;
  childrenWrapperClassname?: string;
  canHorizontalScroll?: boolean;
  withPaddingTitle?: boolean;
  lessMarginTopOnSubtitle?: boolean;
  spacerHeight?: number;
};

const Section: React.FC<TSectionProps> = ({
  title,
  subTitle,
  actionText,
  children,
  withBorder = false,
  onAction,
  rowClassname,
  productRowClassname,
  childrenWrapperClassname,
  canHorizontalScroll = true,
  withPaddingTitle = false,
  lessMarginTopOnSubtitle = false,
  spacerHeight = 16,
}) => {
  return (
    <div className={Styles['wrapper']}>
      <Row
        justify="space-between"
        align="bottom"
        className={withPaddingTitle ? Styles['with-padding-horizontal'] : ''}
      >
        <Col>
          <Row align="middle" className={Styles['section-title-row']}>
            <Col className={Styles['section-title']}>
              <Text variant="black" level={6}>
                {title}{' '}
              </Text>
            </Col>
            {subTitle && (
              <Col
                className={joinClassnames(
                  Styles['section-description'],
                  lessMarginTopOnSubtitle && Styles['less-margin-top'],
                )}
              >
                <Text className={Styles['subtitle']}>{subTitle}</Text>
              </Col>
            )}
          </Row>
        </Col>
        <Col>
          <Text
            variant="black"
            onClick={onAction}
            style={{ cursor: 'pointer' }}
            className={Styles['action-text']}
          >
            {actionText}
          </Text>
        </Col>
      </Row>
      <Spacer
        height={spacerHeight}
        {...(withBorder && {
          style: {
            borderBottom: '1px solid #ebebeb',
          },
        })}
      />
      <div className={productRowClassname}>
        <div className={rowClassname}>
          <Row
            className={cn(
              Styles[
                canHorizontalScroll
                  ? 'children-wrapper-scroll'
                  : 'children-wrapper'
              ],
              childrenWrapperClassname,
            )}
          >
            {children}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Section;
